import { cn } from '@/utils/cn';
import React from 'react';

const ModalCloseButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<'button'> & { children?: React.ReactNode }
>(({ className, children, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        'px-[12px] py-[8px] bg-transparent text-[#0C8DBF] border border-white rounded-[8px] hover:bg-[#A9E7FF] hover:border-[#A9E7FF] transition-colors cursor-pointer text-[14px] font-[400]',
        className
      )}
      {...props}
    >
      {children || 'Close'}
    </button>
  );
});
ModalCloseButton.displayName = 'ModalCloseButton';

export { ModalCloseButton };
